



















import { Vue, Component, Prop } from "vue-property-decorator";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component
export default class QuestionarioReview extends Vue {
  @Prop() docInfo!: any;
  @Prop() soggetto!: string;
  @Prop() nomeSoggetto!: string;
  private dd: any;
  private domande: any;
  private gruppi: any;
  private listaGruppi: any;
  private listaRisposte: any;
  private valoriRispNumeriche: any;
  private subject: string;

  constructor() {
    super();
    this.subject = "";
    this.dd = null;
    this.domande = [];
    this.gruppi = [];
    this.listaGruppi = [];
    this.listaRisposte = [];
    this.valoriRispNumeriche = [
      "decisamente no",
      "più no che si",
      "più si che no",
      "decisamente si"
    ];
  }
  createDoc() {
    const pdfDocGenerator = pdfMake.createPdf(this.dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  loadResponse() {
    var title: string = "";
    if (this.domande[0].domandeGruppo[0].idTipoQuestionario === 1) {
      title = "QUESTIONARIO DI SODDIFAZIONE TIROCINANTE";
    } else if (this.domande[0].domandeGruppo[0].idTipoQuestionario === 2) {
      title = "QUESTIONARIO DI SODDIFAZIONE AZIENDA";
    } else if (this.domande[0].domandeGruppo[0].idTipoQuestionario === 4) {
      title = "QUESTIONARIO WORKSHOP - AZIENDA";
    } else if (this.domande[0].domandeGruppo[0].idTipoQuestionario === 5) {
      title = "QUESTIONARIO WORKSHOP - ALLIEVO/A";
    }
    var tmpStr = '{ "pageSize": "A4",' + ' "content": [';
    if (
      this.docInfo[0].idTipoQuestionario !== 4 &&
      this.docInfo[0].idTipoQuestionario !== 5
    ) {
      tmpStr +=
        '{ "text": "' +
        title +
        '", "bold": "true", "alignment": "center", "fontSize": 10, "margin": [0, 0, 0, 20] },';
      tmpStr +=
        '{ "text": "Tirocinante: ' +
        this.domande[0].domandeGruppo[0].tirocinante +
        '", "style": "bodyText" },';
      tmpStr +=
        '{ "text": "Classe: ' +
        this.domande[0].domandeGruppo[0].classeTirocinante +
        '", "style": "bodyText" },';
      tmpStr +=
        '{ "text": "Azienda Ospitante: ' +
        this.domande[0].domandeGruppo[0].azienda +
        '", "style": "bodyText" },';
      tmpStr +=
        '{ "text": "Città: ' +
        this.domande[0].domandeGruppo[0].comuneTirocinio +
        '", "style": "bodyText" },';
      tmpStr +=
        '{ "text": "Periodo: dal ' +
        this.domande[0].domandeGruppo[0].dataInizio +
        " al " +
        this.domande[0].domandeGruppo[0].dataFine +
        '", "style": "bodyText" },';
      tmpStr +=
        '{ "text": "Attività Svolta: ' +
        this.domande[0].domandeGruppo[0].attivitaTirocinio +
        '", "style": "bodyText" },';
    }

    if (
      this.docInfo[0].idTipoQuestionario === 4 ||
      this.docInfo[0].idTipoQuestionario === 5
    ) {
      tmpStr +=
        '{ "text": "' +
        title +
        '", "bold": "true", "alignment": "center", "fontSize": 10, "margin": [0, 0, 0, 20] },';
      tmpStr +=
        '{ "text": "' +
        this.subject +
        ": " +
        this.nomeSoggetto +
        '", "bold": "true", "margin": [0, 0, 0, 20],"style": "tableTitle" },';
    }

    for (let i = 0; i < this.domande.length; i++) {
      if (
        this.docInfo[0].idTipoQuestionario !== 4 &&
        this.docInfo[0].idTipoQuestionario !== 5
      ) {
        tmpStr +=
          '{ "text": "' +
          this.domande[i].descrizioneGruppo +
          '", "style": "tableTitle"},';
      }
      tmpStr += '{ "table": {';
      tmpStr += ' "widths": [350,"*"],';
      tmpStr += ' "body": [';
      for (let j = 0; j < this.domande[i].domandeGruppo.length; j++) {
        tmpStr += "[";
        tmpStr +=
          '{ "text": "' +
          this.domande[i].domandeGruppo[j].descrizioneDomanda +
          '" , "style": "tableCol1"},';
        tmpStr += "[";
        for (
          let y = 0;
          y < this.domande[i].domandeGruppo[j].rangeRisposta;
          y++
        ) {
          if (this.domande[i].domandeGruppo[j].idTipoDomanda === 1) {
            if (y < this.domande[i].domandeGruppo[j].rangeRisposta - 1) {
              tmpStr +=
                '{ "text": "' +
                this.signResponse(
                  y + 1,
                  this.domande[i].domandeGruppo[j].risposta
                ) +
                " " +
                this.valoriRispNumeriche[y] +
                '" , "style": "tableText"},';
            } else {
              tmpStr +=
                '{ "text": "' +
                this.signResponse(
                  y + 1,
                  this.domande[i].domandeGruppo[j].risposta
                ) +
                " " +
                this.valoriRispNumeriche[y] +
                '" , "style": "tableText"}';
            }
          } else if (this.domande[i].domandeGruppo[j].idTipoDomanda === 2) {
            if (y < this.domande[i].domandeGruppo[j].rangeRisposta - 1) {
              tmpStr +=
                '{ "text": "' +
                this.signResponse(
                  y + 1,
                  this.domande[i].domandeGruppo[j].risposta
                ) +
                " " +
                this.responseText(y, this.domande[i].domandeGruppo[j]) +
                '" , "style": "tableText"},';
            } else {
              tmpStr +=
                '{ "text": "' +
                this.signResponse(
                  y + 1,
                  this.domande[i].domandeGruppo[j].risposta
                ) +
                " " +
                this.responseText(y, this.domande[i].domandeGruppo[j]) +
                '" , "style": "tableText"}';
            }
          }
        }
        tmpStr += "]";
        if (
          j < this.domande[i].domandeGruppo.length - 1 ||
          this.domande[i].domandeGruppo[j].testoNota !== null
        ) {
          tmpStr += "],";
          if (this.domande[i].domandeGruppo[j].testoNota !== null) {
            tmpStr +=
              '[{ "text": "' +
              this.domande[i].domandeGruppo[j].testoNota +
              '", "style": "tableText"},';
            tmpStr +=
              '{ "text": "' +
              this.domande[i].domandeGruppo[j].noteRisposta +
              '", "style": "tableText"}';
            if (j < this.domande[i].domandeGruppo.length - 1) {
              tmpStr += "],";
            } else {
              tmpStr += "]";
            }
          }
        } else {
          tmpStr += "]";
        }
      }
      tmpStr += "]}},";
    }

    tmpStr +=
      '{ "text": "Note Aggiuntive: ' +
      this.domande[0].domandeGruppo[0].noteQuestionario +
      '", "style": "bodyText", "margin": [0, 20, 0, 0]}';

    tmpStr += "],";
    tmpStr += '"styles": {';
    tmpStr += '"bodyText": { "fontSize": "8",  "justified": "true"},';
    tmpStr +=
      '"tableTitle": { "fontSize": "8", "bold": "true", "alignment": "left", "margin": [0,10,0,5]},';
    tmpStr += '"tableCol1": { "fontSize": 8, "alignment": "left"},';
    tmpStr += '"tableText": { "fontSize": 8 }';
    tmpStr += "}";
    tmpStr += "}";
    this.dd = JSON.parse(tmpStr);

    this.createDoc();
  }

  signResponse(val: number, response: number): string {
    if (val === response) {
      return "(X)";
    } else {
      return "( )";
    }
  }

  responseText(val: number, domanda: any) {
    switch (val) {
      case 0: {
        return domanda.opzione1;
      }
      case 1: {
        return domanda.opzione2;
      }
      case 2: {
        return domanda.opzione3;
      }
      case 3: {
        return domanda.opzione4;
      }
      case 4: {
        return domanda.opzione5;
      }
      case 5: {
        return domanda.opzione6;
      }
      case 6: {
        return domanda.opzione7;
      }
      case 7: {
        return domanda.opzione8;
      }
      case 8: {
        return domanda.opzione9;
      }
      case 9: {
        return domanda.opzione10;
      }
      case 10: {
        return domanda.opzione11;
      }
      case 11: {
        return domanda.opzione12;
      }
      case 12: {
        return domanda.opzione13;
      }
    }
  }

  created() {
    var listaDomandeGruppo: any[] = [];
    this.docInfo.forEach((element: any) => {
      if (!this.gruppi.includes(element.idGruppoDomanda)) {
        this.gruppi.push(element.idGruppoDomanda);
      }
    });
    this.gruppi.forEach((gruppo: any) => {
      var gruppoElem = {
        idGruppo: 0,
        descrizioneGruppo: "",
        domandeGruppo: []
      };
      gruppoElem.idGruppo = gruppo;
      this.docInfo.forEach((domanda: any) => {
        if (domanda.idGruppoDomanda === gruppoElem.idGruppo) {
          gruppoElem.descrizioneGruppo = domanda.descrizioneGruppoDomanda;
          gruppoElem.domandeGruppo.push({
            //@ts-ignore
            idDomanda: domanda.idDomanda,
            //@ts-ignore
            descrizioneDomanda: domanda.descrizioneDomanda,
            //@ts-ignore
            rangeRisposta: domanda.rangeRisposta,
            //@ts-ignore
            risposta: domanda.risposta,
            //@ts-ignore
            idTipoDomanda: domanda.idTipoDomanda,
            //@ts-ignore
            opzione1: domanda.opzione1,
            //@ts-ignore
            opzione2: domanda.opzione2,
            //@ts-ignore
            opzione3: domanda.opzione3,
            //@ts-ignore
            opzione4: domanda.opzione4,
            //@ts-ignore
            opzione5: domanda.opzione5,
            //@ts-ignore
            opzione6: domanda.opzione6,
            //@ts-ignore
            opzione7: domanda.opzione7,
            //@ts-ignore
            opzione8: domanda.opzione8,
            //@ts-ignore
            opzione9: domanda.opzione9,
            //@ts-ignore
            opzione10: domanda.opzione10,
            //@ts-ignore
            opzione11: domanda.opzione11,
            //@ts-ignore
            opzione12: domanda.opzione12,
            //@ts-ignore
            opzione13: domanda.opzione13,
            //@ts-ignore
            tirocinante: domanda.tirocinante,
            //@ts-ignore
            comuneTirocinio: domanda.comuneTirocinio,
            //@ts-ignore
            dataInizio: domanda.dataInizio,
            //@ts-ignore
            dataFine: domanda.dataFine,
            //@ts-ignore
            attivitaTirocinio: domanda.attivitaTirocinio,
            //@ts-ignore
            classeTirocinante: domanda.classeTirocinante,
            //@ts-ignore
            azienda: domanda.azienda,
            //@ts-ignore
            idTipoQuestionario: domanda.idTipoQuestionario,
            //@ts-ignore
            noteQuestionario: domanda.noteQuestionario,
            //@ts-ignore
            testoNota: domanda.testoNota,
            //@ts-ignore
            rispostaMultipla: domanda.rispostaMultipla,
            //@ts-ignore
            noteRisposta: domanda.noteRisposta
          });
        }
      });
      listaDomandeGruppo.push(gruppoElem);
    });
    this.domande = listaDomandeGruppo;
    if (this.soggetto === "azienda") {
      this.subject = "Azienda";
    } else if (this.soggetto === "allievo") {
      this.subject = "Allievo";
    } else {
      this.subject = this.soggetto;
    }
    this.loadResponse();
  }
}
